import { h, Fragment } from 'preact';
import { useProduct } from './product-context';

const LengthVariantSelector = () => {
  const { handleVariantChange, activeProduct, lengthOptions, selectedOptions } =
    useProduct();
  const currentLength = selectedOptions.Length;
  const { name, values } = lengthOptions;
  if (!values) return null;

  // Build an array of relevant variants for the current product based on the selected options
  const relevantVariants = activeProduct.variants.filter((variant) => {
    return (
      variant.option1 === selectedOptions.Size &&
      variant.option2 === selectedOptions.Color
    );
  });

  const valueEls = values.map((value) => {
    const isAvailable = relevantVariants.find(
      (variant) => variant.option3 === value,
    ).available;
    return (
      <button
        className={`${
          currentLength === value
            ? 'border-text-1 bg-text-1 text-white'
            : 'border-grey-400 bg-white text-black'
        } ${
          !isAvailable && 'text-grey-400 unavailable'
        } flex items-center justify-center px-[14px] py-[10px] rounded-md text-sm border`}
        onClick={() => handleVariantChange(value, name)}
      >
        {value}
      </button>
    );
  });

  const additionalText = () => {
    if (currentLength.toLowerCase() === 'high rise') {
      return TMW.Strings.product.highriseText;
    }
    if (currentLength.toLowerCase() === 'low rise') {
      return TMW.Strings.product.lowriseText;
    }
    return '';
  };

  return (
    <>
      <div className="uppercase text-[14px] leading-[18px] mb-[12px]">
        {name}
      </div>
      <div
        className="flex flex-wrap gap-y-[10px] gap-x-[8px] mb-[12px]"
        id="lengthselector"
      >
        {valueEls}
      </div>
      <div className="italic mb-[30px]">{additionalText()}</div>
    </>
  );
};

export default LengthVariantSelector;
